"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListaTecnica = void 0;
var ListaTecnica = /** @class */ (function () {
    function ListaTecnica(_a) {
        var _b = _a._id, _id = _b === void 0 ? { m: '', V: '' } : _b, _c = _a.VERSAO, VERSAO = _c === void 0 ? '' : _c, _d = _a.VER_FORN, VER_FORN = _d === void 0 ? '' : _d, _e = _a.COMPONENTES, COMPONENTES = _e === void 0 ? new Array() : _e, _f = _a.CD_MATERIAL, CD_MATERIAL = _f === void 0 ? '' : _f, _g = _a.cdFabricaPrep, cdFabricaPrep = _g === void 0 ? '' : _g, _h = _a.no, no = _h === void 0 ? '' : _h, _j = _a.tempo, tempo = _j === void 0 ? 0 : _j, _k = _a.tempoPreparacao, tempoPreparacao = _k === void 0 ? 0 : _k, _l = _a.chaveRecCrit, chaveRecCrit = _l === void 0 ? { material: '', cdFabrica: '' } : _l, _m = _a.CD_FABRICA, CD_FABRICA = _m === void 0 ? '' : _m;
        this._id = _id;
        this.VERSAO = VERSAO;
        this.VER_FORN = VER_FORN;
        this.COMPONENTES = COMPONENTES;
        this.CD_MATERIAL = CD_MATERIAL;
        this.cdFabricaPrep = cdFabricaPrep;
        this.no = no;
        this.tempo = tempo;
        this.tempoPreparacao = tempoPreparacao;
        this.chaveRecCrit = chaveRecCrit;
        this.CD_FABRICA = CD_FABRICA;
    }
    return ListaTecnica;
}());
exports.ListaTecnica = ListaTecnica;
//# sourceMappingURL=ListaTecnica.js.map